import useQuickButtons from "../../../../hooks/useQuickButtons";
import { Restaurant } from "../../../../api/types";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { navigationTargetState } from "../../../../recoil/store";
import { getDistanceKm } from "../../../../utils/common";
import { geoCoordState } from "../../../../recoil/geo";
import { PubMoreWrapper } from "../../FranchisePubs/style";
import { Overlay } from "./styles/Rank";

interface RestaurantMoreProps {
  data: Restaurant | null;
  setShowMoreOption: (value: boolean) => void;
  setSelectedStore: (value: Restaurant | null) => void;
}

const RestaurantMore = ({
  data,
  setShowMoreOption,
  setSelectedStore,
}: RestaurantMoreProps) => {
  const { openPhoneCall } = useQuickButtons();
  const setNavigationTarget = useSetRecoilState(navigationTargetState);
  const { latitude, longitude } = useRecoilValue(geoCoordState);

  return (
    <>
      <Overlay onTouchMove={(e) => e.preventDefault()} />
      <PubMoreWrapper>
        <div className="info">
          <div className="title-row">
            <div className="name">{data?.restaurantName}</div>
            <img
              src="/image-web/Holdem%20Now/Icon/Close.svg"
              onClick={() => {
                setShowMoreOption(false);
                setSelectedStore(null);
              }}
            />
          </div>
          <div className="address">{data?.address}</div>
          <div className="info-row">
            <div className="item">
              <img className="icon" src="/image-web/Icon/Map%20pin/small.svg" />
              <span className="text">
                {data &&
                  getDistanceKm(latitude, longitude, data?.lat, data?.lon)}{" "}
                km
              </span>
            </div>
          </div>
        </div>
        <div className="menu-wrapper">
          <div
            className="item"
            onClick={() => {
              if (!data) return;
              setShowMoreOption(false);
              setSelectedStore(null);
              openPhoneCall(data?.restaurantName, data?.phoneNumber);
            }}
          >
            <img src="/image-web/search/Icon/phone.svg" />
            <span>전화</span>
          </div>
          <div
            className="item"
            onClick={() => {
              if (!data) return;
              setShowMoreOption(false);
              setSelectedStore(null);
              setNavigationTarget({
                lat: data?.lat,
                lon: data?.lon,
                newAddress: data.address,
                detailAddress: "",
                cafeName: data.restaurantName,
              });
            }}
          >
            <img src="/image-web/store/Navigation.svg" />
            <span>길안내</span>
          </div>
        </div>
      </PubMoreWrapper>
    </>
  );
};

export default RestaurantMore;
